module.exports = {"component":"avatar","status":"prod","display-name":"Avatars","last-accessibility-review":{"date-iso-8601":"2018/01/18","commit-sha":"ad6b6c6523ee21cada11be5f7ea4d99abc530726"},"SLDS-component-path":"/components/avatar","url-slug":"avatars"}


//////////////////
// WEBPACK FOOTER
// ./components/avatar/docs.json
// module id = 170
// module chunks = 0